export function focus(node: HTMLElement) {
  node.focus();
}

export function delayedFocus(node: HTMLElement) {
  // note: not sure why I need this but e.g. if I have CodeMirror,
  // the codemirror element regains focus if I set my focus
  // immediately on mount. Delay of 100 seems to fix it (50 was too low)
  // is it just with codemirror or more general?
  setTimeout(() => node.focus(), 100);
}
